import React, { useState } from "react";
import Ribbon, { Category } from "./Ribbon";
import { DataTable } from "../../Components/DataTable";
import { loginLogColumns, auditLogColumns } from "./TableConfig";
import { useLoginLogs } from "../../hooks/useLoginLogs"; // Το hook για logins
import { useAuditLogs } from "../../hooks/useAuditLogs"; // Το hook για audits

export const AdminTableContainer: React.FC = () => {
  const [category, setCategory] = useState<Category>("login_logs");
  
  // Χρησιμοποιούμε τα ξεχωριστά hooks σας
  const loginQuery = useLoginLogs();
  const auditQuery = useAuditLogs();

  // Επιλέγουμε τα δεδομένα, το loading και τις στήλες ανάλογα με την κατηγορία
  const data = category === "login_logs" ? loginQuery.loginLogs : auditQuery.auditLogs;
  const loading = category === "login_logs" ? loginQuery.isLoading : auditQuery.isLoading;
  const columns = category === "login_logs" ? loginLogColumns : auditLogColumns;

  return (
    <div className="flex flex-col h-full">
      <Ribbon activeCategory={category} onChange={setCategory} />

      <div className="flex-1 p-6 overflow-auto">
        <DataTable 
          columns={columns} 
          data={data || []} 
          loading={loading} 
        />
      </div>
    </div>
  );
};